import React from 'react'
import { FormControlLabel } from '@atd/rui-base.mui.form-control-label'
import { IconButton } from '@atd/rui-base.mui.icon-button'
import { Radio } from '@atd/rui-base.mui.radio'
import { RadioGroup } from '@atd/rui-base.mui.radio-group'
import ValidatedTextField from '../commonComponents/validatedTextField'


import InfoIcon from '@mui/icons-material/Info'

import { getMenuItemsForProductDDI } from '../commonComponents/unitMenuItems'

class ProductDetails extends React.Component {
    handleInfo = () => {
        this.props.mixReviewRequest(this.props.data.id)
    }

    getRateLabel = () => {
        if (this.props.data.mode === 'targetRate') { return 'Target Rate' }
        else if (this.props.data.mode === 'rxMap') { return 'Default Rate' }
    }
    getRxSection = (rateUnits) => {
        if (this.props.data.mode !== 'rxMap') { return }

        return (
            <div>
                <ValidatedTextField
                    className="selectField"
                    value={this.props.data.rxMapName || this.props.data.rxMapId}
                    label="Rx Map"
                    disabled={this.props.disabled}
                    name="rxMapSelect"
                >
                </ValidatedTextField>
                <ValidatedTextField
                    className="selectField"
                    label="Map Column"
                    InputLabelProps={{ shrink: true }}
                    value={this.props.data.rxMapColumnId}
                    disabled={this.props.disabled}
                    name="rxMapColumn"
                />
                <ValidatedTextField
                    className="selectField"
                    label="Map Unit"
                    value={this.props.data.rxMapUnit}
                    disabled={this.props.disabled}
                    name="rxMapUnit"
                />
            </div>
        )
    }
    renderRateInfo = () => {
        const rateUnits = getMenuItemsForProductDDI(this.props.data.ddiId)
        const rateLabel = this.getRateLabel()
        const rxSection = this.getRxSection(rateUnits)

        return (
            <div className="rates" name="rateInfo">
                {rxSection}
                <ValidatedTextField
                    className="textField"
                    label={rateLabel}
                    defaultValue={this.props.data.displayRate}
                    disabled={this.props.disabled}
                    name="displayRate"
                />
                <ValidatedTextField
                    className="selectField"
                    value={this.props.data.userDisplayUnit}
                    disabled={this.props.disabled}
                    name="rateUnits"
                />
            </div>
        )

    }

    renderRateMode = () => {
        return (
            <div className="radioButtonGroup" name="rateRadioButtons">
                <label>Rate:</label>
                <RadioGroup
                    name="rateMode"
                    value={this.props.data.mode}
                >
                    <FormControlLabel
                        value="targetRate"
                        label=""
                        control={
                            <Radio
                                className="radioButton"
                                disabled={this.props.disabled}
                                checkedIcon={<img className="clickedIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Target.svg`}/>}
                                icon={<img className="clickableIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Target.svg`}/>}
                                name="targetRateButton"
                            />
                        }
                    />
                    <FormControlLabel
                        value="rxMap"
                        label=""
                        control={
                            <Radio
                                className="radioButton"
                                disabled={this.props.disabled}
                                checkedIcon={<img className="clickedIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Rx.svg`}/>}
                                icon={<img className="clickableIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Rx.svg`}/>}
                                name="rxMapButton"
                            />
                        }
                    />
                </RadioGroup>
            </div>
        )
    }

    render() {
        const rateEntry = this.renderRateInfo()
        const rateMode = this.renderRateMode()

        return (
            <div style={{borderBottom: 'solid'}}>
                <ValidatedTextField
                    className="mixSelectField"
                    value={this.props.data.mix.name}
                    style={{marginTop: '10px'}}
                    disabled={this.props.disabled}
                    name={`Mix:${this.props.data.mix.guid}`}
                />
                <IconButton
                    className="mixInfoButton_review"
                    name="mixInfoButton"
                    onClick={this.handleInfo}>
                    <InfoIcon/>
                </IconButton>
                <div className="rowFlex">
                    {rateMode}
                    <div style={{ display: 'inline-block', width: '10%' }} />
                    {rateEntry}
                </div>
            </div>
        )
    }
}

export default (ProductDetails)
